import {
  LinkType,
  createToolbarComponent,
  HotkeyUtilities,
  RichTextEditorToolbar as Toolbar,
  findLink,
} from '@shopify/online-store-ui';
import {useI18n} from '@shopify/react-i18n';

import {link} from './icons';

export const Link = createToolbarComponent(
  LinkType,
  ({editor, plugin: {type, hotkey}, disabled}) => {
    const active = editor.selection
      ? findLink(editor, editor.selection) != null
      : false;

    const [i18n] = useI18n();
    const action = active ? i18n.translate('edit') : i18n.translate('insert');
    const tooltip = disabled
      ? null
      : i18n.translate('tooltip', {
          action,
          hotkey: HotkeyUtilities.formatHotKeys(hotkey || ''),
        });

    return (
      <Toolbar.Button
        icon={link}
        tooltip={tooltip}
        active={active}
        type={type}
        disabled={disabled}
      />
    );
  },
);
